import React, { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const DONE = new Set(["Collected", "Cancelled"]);

const fmt = (ms) => {
  const abs = Math.abs(ms);
  const h = Math.floor(abs / 3600000);
  const m = Math.floor((abs % 3600000) / 60000);
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
};

export const Countdown = ({ job, className = "" }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 60000); return () => clearInterval(t); }, []);
  if (!job?.due_at || DONE.has(job.status) || (job.due_hours ?? 99) > 24) return null;
  const ms = new Date(job.due_at).getTime() - now;
  const late = ms < 0;
  const soon = !late && ms < 2 * 3600000;
  const cls = late ? "bg-rose-600 text-white border-rose-700 animate-pulse" : soon ? "bg-orange-100 text-orange-800 border-orange-300" : "bg-emerald-50 text-emerald-800 border-emerald-300";
  return (
    <span data-testid={`countdown-${job.job_number}`} title={`Due ${new Date(job.due_at).toLocaleString("en-MY")}`}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[10px] font-bold font-mono ${cls} ${className}`}>
      <Timer className="w-3 h-3" /> {late ? `LATE ${fmt(ms)}` : `${fmt(ms)} left`}
    </span>
  );
};
